module.exports = __webpack_public_path__ + "img/send.40e57fc0.png";